"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentFormContainer = void 0;

var react_1 = __importStar(require("react"));

var PaymentForm_models_1 = require("./PaymentForm.models");

var PaymentForm_utils_1 = require("./PaymentForm.utils");

var PaymentForm_1 = require("./PaymentForm");

var validators_1 = require("../../utils/validators");

var PaymentFormContainer = function PaymentFormContainer(_a) {
  var supportedCountries = _a.supportedCountries,
      successMessage = _a.successMessage,
      submitButtonText = _a.submitButtonText,
      onSubmit = _a.onSubmit,
      error = _a.error,
      couponError = _a.couponError,
      user = _a.user,
      price = _a.price,
      renderCardInput = _a.renderCardInput,
      onPricingChanged = _a.onPricingChanged,
      initialPaymentFormFieldValues = _a.initialPaymentFormFieldValues,
      collapsedBreakpoint = _a.collapsedBreakpoint,
      _b = _a.form,
      form = _b === void 0 ? react_1.createRef() : _b,
      handleToggle = _a.handleToggle,
      hide = _a.hide,
      priceMessage = _a.priceMessage,
      priceMessageForTotal = _a.priceMessageForTotal,
      errorShouldReplaceLabel = _a.errorShouldReplaceLabel,
      useUpdateBillingForm = _a.useUpdateBillingForm,
      submitButtonStyle = _a.submitButtonStyle,
      hideCouponLabel = _a.hideCouponLabel;

  var _c = react_1.useState(PaymentForm_models_1.Currency.GBP),
      currency = _c[0],
      setCurrency = _c[1];

  var _d = react_1.useState({}),
      errors = _d[0],
      setErrors = _d[1];

  var _e = react_1.useState(''),
      errorMessage = _e[0],
      setErrorMessage = _e[1];

  var _f = react_1.useState(false),
      isSubmitting = _f[0],
      setIsSubmitting = _f[1];

  var _g = react_1.useState({
    couponCode: true
  }),
      fieldsToggledOff = _g[0],
      setFieldsToggledOff = _g[1];

  var _h = react_1.useState(false),
      showCurrencyWarning = _h[0],
      setShowCurrencyWarning = _h[1];

  var _j = react_1.useState(__assign({
    firstName: '',
    lastName: '',
    email: '',
    street: '',
    street2: '',
    city: '',
    region: '',
    country: '',
    postalCode: '',
    couponCode: ''
  }, initialPaymentFormFieldValues)),
      paymentFormFields = _j[0],
      setPaymentFormFields = _j[1];

  var handleChange = function handleChange(key, value) {
    var _a;

    var nextPaymentFormFields = __assign(__assign({}, paymentFormFields), (_a = {}, _a[key] = value, _a));

    switch (key) {
      case 'country':
        var currencyFromCountryCode = PaymentForm_utils_1.getCurrencyFromCountryCode(value);
        setCurrency(currencyFromCountryCode);
        setShowCurrencyWarning(currency !== currencyFromCountryCode);
        onPricingChanged(nextPaymentFormFields, currencyFromCountryCode);
        break;

      case 'postalCode':
        onPricingChanged(nextPaymentFormFields, currency);
        break;
    }

    setPaymentFormFields(nextPaymentFormFields);
  };

  var handleToggleState = function handleToggleState(fieldID, open) {
    setFieldsToggledOff(function (prevState) {
      var _a;

      return __assign(__assign({}, prevState), (_a = {}, _a[fieldID] = !open, _a));
    }); // Remove field error if the field is toggled off

    !open && errors[fieldID] && setErrors(function (errors) {
      var _a;

      return __assign(__assign({}, errors), (_a = {}, _a[fieldID] = undefined, _a));
    });
    handleToggle && handleToggle(fieldID, open);
  };

  var handleApplyDiscount = function handleApplyDiscount() {
    // trigger a pricing change when the apply button is clicked
    onPricingChanged(paymentFormFields, currency);
  };

  react_1.useEffect(function () {
    if (error) {
      setErrorMessage(error);
    }
  }, [error]);
  react_1.useEffect(function () {
    if (useUpdateBillingForm) {
      var values = __assign({}, paymentFormFields);

      delete values.couponCode;
      delete values.email;
      setPaymentFormFields(values);
    }
  }, []);

  var validate = function validate() {
    var errors = {};

    if (!useUpdateBillingForm) {
      if (paymentFormFields.couponCode && paymentFormFields.couponCode.length === 0 && (hide === null || hide === void 0 ? void 0 : hide.couponCode) !== true && fieldsToggledOff.couponCode !== true) {
        errors.couponCode = 'Please fill out the coupon code';
      }

      if (paymentFormFields.email && !validators_1.isValidEmail(paymentFormFields === null || paymentFormFields === void 0 ? void 0 : paymentFormFields.email) && (hide === null || hide === void 0 ? void 0 : hide.email) !== true) {
        errors.email = 'Please enter a valid email address';
      }
    }

    if (paymentFormFields.firstName.length === 0 && (hide === null || hide === void 0 ? void 0 : hide.firstName) !== true) {
      errors.firstName = 'Please enter your first name';
    }

    if (paymentFormFields.lastName.length === 0 && (hide === null || hide === void 0 ? void 0 : hide.lastName) !== true) {
      errors.lastName = 'Please enter your last name';
    }

    if (paymentFormFields.street.length === 0 && (hide === null || hide === void 0 ? void 0 : hide.street) !== true) {
      errors.street = 'Please enter the first line of your address';
    }

    if (paymentFormFields.city.length === 0 && (hide === null || hide === void 0 ? void 0 : hide.city) !== true) {
      errors.city = 'Please enter a valid city';
    }

    if (paymentFormFields.postalCode.length === 0 && (hide === null || hide === void 0 ? void 0 : hide.postalCode) !== true) {
      errors.postalCode = 'Please enter a valid zip or postal code';
    } // state is required for USA transactions


    if (paymentFormFields.country === PaymentForm_models_1.CountryCode.US && paymentFormFields.region.length === 0 && (hide === null || hide === void 0 ? void 0 : hide.region) !== true) {
      errors.region = 'Please enter your state/province';
    }

    return errors;
  };

  var handleSubmit = function handleSubmit(event) {
    return __awaiter(void 0, void 0, void 0, function () {
      var errors;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            event.preventDefault();
            setIsSubmitting(true);
            setErrors({});
            setErrorMessage('');
            errors = validate();

            if (Object.entries(errors).length > 0) {
              setErrors(errors);
              setErrorMessage('Please correct the errors below');
              setIsSubmitting(false);
              return [2
              /*return*/
              ];
            }

            return [4
            /*yield*/
            , onSubmit(paymentFormFields, user, currency)];

          case 1:
            _a.sent();

            setIsSubmitting(false);
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  react_1.useEffect(function () {
    if (PaymentForm_utils_1.isInArray(paymentFormFields.country, supportedCountries)) {
      // country value updates whenever onChange happens, not submission, so before validation
      // we need to make sure we only clear the country error and leave any other errors
      setErrors(__assign(__assign({}, errors), {
        country: undefined
      }));
    } else {
      setShowCurrencyWarning(false);
      setErrors(__assign(__assign({}, errors), {
        country: "Sorry, we do not currently support software purchases in " + PaymentForm_utils_1.getCountryNameFromCode(paymentFormFields.country)
      }));
    }
  }, [paymentFormFields.country, supportedCountries]);
  react_1.useEffect(function () {
    if (user.id) {
      setCurrency(PaymentForm_utils_1.getCurrencyFromCountryCode(user.country));
      setPaymentFormFields(__assign(__assign({}, paymentFormFields), {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        country: user.country
      }));
    }
  }, [user]);
  react_1.useEffect(function () {
    if (couponError === null || couponError === void 0 ? void 0 : couponError.message) {
      setErrors(__assign(__assign({}, errors), {
        couponCode: couponError.message
      }));
    } else {
      // if there's no longer an error we need to clear it from the errors object
      var updatedErrors = __assign({}, errors);

      if (updatedErrors.couponCode) {
        delete updatedErrors.couponCode;
      }

      setErrors(updatedErrors);
    }
  }, [couponError]);
  return react_1.default.createElement(PaymentForm_1.PaymentForm, {
    errorMessage: errorMessage,
    isSubmitting: isSubmitting,
    showCurrencyWarning: showCurrencyWarning,
    successMessage: successMessage,
    price: price,
    errors: errors,
    form: form,
    handleChange: handleChange,
    handleSubmit: handleSubmit,
    handleToggle: handleToggleState,
    handleApplyDiscount: handleApplyDiscount,
    renderCardInput: renderCardInput,
    submitButtonText: submitButtonText,
    hide: hide,
    taxMessage: price ? PaymentForm_utils_1.getTaxMessage(price.taxInclusive, currency) : '',
    priceMessage: priceMessage,
    priceMessageForTotal: priceMessageForTotal,
    formValues: paymentFormFields,
    collapsedBreakpoint: collapsedBreakpoint,
    errorShouldReplaceLabel: errorShouldReplaceLabel,
    useUpdateBillingForm: useUpdateBillingForm,
    submitButtonStyle: submitButtonStyle,
    hideCouponLabel: hideCouponLabel
  });
};

exports.PaymentFormContainer = PaymentFormContainer;